export default __webpack_public_path__ + "de11cba960f8ceede7e4f34128d38ca8.png";